import React, { useRef } from 'react'
import TestimonyCard from './TestimonyCard'
import { FcCollapse, FcExpand } from 'react-icons/fc'
import Slider from 'react-slick'
import { testimonyData } from './testimonyData'

const Testimony = () => {
  const sliderRef = useRef(null)
  return (
    <section className="mx-auto max-w-7xl py-8 md:pb-16 md:pt-10 px-6">
      <div className="pb-8 sm:pb-12">
        <h1 className="font-bold text-3xl md:text-5xl text-center">
          Clients certainly like <br className="hidden sm:block" /> working with us
        </h1>
      </div>

      <div className="w-full flex items-center flex-wrap py-8 md:pt-10 lg:px-6 lg:px-8">
        <div className="w-full sm:w-2/5 md:w-1/2 pb-4 sm:py-12 md:py-16 lg:py-20 xl:pb-28 lg:pl-10">
          <h1 className="text-center sm:text-left text-3xl md:text-5xl font-bold leading-snug"
            // data-aos="fade-right" data-aos-duration="1000"
          >
            What People Say <br className="lg:block" /> About Us
          </h1>
        </div>

        <div className="w-full sm:w-3/5 md:w-1/2 relative pr-6 sm:pr-8 lg:pr-20">
          <Slider
            dots={false}
            ref={sliderRef}
            slidesToShow={1}
            slidesToScroll={1}
            infinite
            autoplay
            autoplaySpeed={5000}
            vertical
            verticalSwiping
          >
            {testimonyData.map((testimony, index) => {
              return (
                <div className="w-full min-h-[16rem]" key={index}>
                  <TestimonyCard testimony={testimony} />
                </div>
              )
            })}
          </Slider>

          <div className="absolute inset-y-0 right-0 px-0 lg:px-4 flex flex-col items-center justify-center space-y-4 sm:space-x-0">
            <div className="p-3 md:p-4 rounded-full text-oya-ghana-black hover:bg-gray-100 cursor-pointer"
              onClick={() => sliderRef.current.slickNext()}
            >
              <FcCollapse className="text-oya-ghana-black" />
            </div>
            <div className="p-3 md:p-4 rounded-full text-oya-ghana-black hover:bg-gray-100 cursor-pointer"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <FcExpand className="text-oya-ghana-black" />
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default Testimony
